import $ from 'jquery';
import { get } from 'lodash';
import { getUser } from '~src/user';
import {
  QR_TYPE_WEBSITE,
  QR_TYPE_WHATSAPP,
  QR_TYPE_PHONE,
} from '~config/editorConstants';

export const setDefaultQrCodeValues = async (category = '') => {
  if (!category) {
    return;
  }

  const { user } = await getUser();

  const defaultValuesMapping = {
    [QR_TYPE_WEBSITE]: get(user, 'org_pointer.sito', ''),
    [QR_TYPE_WHATSAPP]: get(user, 'org_pointer.cellulare1', ''),
    [QR_TYPE_PHONE]: get(user, 'org_pointer.telefono1', ''),
  };

  let suggestedValue = defaultValuesMapping[category];

  if (
    typeof defaultValuesMapping[category] === 'undefined' ||
    !suggestedValue
  ) {
    // no default value to set
    $('#qr-form-user-input').val('');
    return;
  }

  if (suggestedValue) {
    $('#qr-form-user-input').val(suggestedValue);
  }
};
